import { Tooltip, IconButton } from "../../../../components";

const ButtonMenu = ({ setOpenAnexo, buscarAnexos }) => {
  const onClickOpenAnexos = () => {
    buscarAnexos();
    setOpenAnexo(true);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <Tooltip title="Anexos" arrow>
        <IconButton onClick={() => onClickOpenAnexos()}>
          <i className="ph-fill ph-paperclip" style={{ fontSize: 18 }}></i>
        </IconButton>
      </Tooltip>
      <Tooltip title="Imprimir" arrow>
        <IconButton color="default">
          <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ButtonMenu;
